import * as React from 'react';
import { connect } from 'react-redux';
import { CAPTURE_CAR_DETAILS, DASHBOARD, PERSONAL_INSURANCE } from '../../../routes/routes';
import './CaptureImages.css';
import NeedHelp from '../../BaseTemplate/SSPCustomComponentLibrary/NeedHelp/NeedHelp';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import { showSelfInspectStepsScreen } from '../../../actions/fullscreenActions';
import { setSelfInspectStep } from '../../../actions/profileActions';
import { getSelfInspectPhotos, showPhotoError } from '../../../actions/selfInspectActions';
import { navigateTo } from '../../../actions/navigationActions';
import { Image } from 'react-bootstrap';
import { showCallMeModal } from '../../../actions/modalActions';

class CaptureImages extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.handleCaptureStep = this.handleCaptureStep.bind(this);
        this.getColClassName = this.getColClassName.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleCallMeBack = this.handleCallMeBack.bind(this);

        this.state = {
            coverToggle: false,
            selectedCover: false
        }
    }

    handleCallMeBack(e: any) {
        this.props.handleCallMeBack();
    }

    getColClassName(name) {
        const prefix = "col" + " ";

        switch (name) {
            case "mileage reading": return prefix + "mileage-reading-1";
            case "dashboard": return prefix + "dashboard-photo";
            case "mileagephoto": return prefix + "car-mileage";
            case "mileagereading2": return prefix + "mileage-reading-2";
            case "leatherseats": return prefix + "leather-seats";
            case "optionalphotos": return prefix + "optional-photos";
            case "tow, roll & bull bar": return prefix + "row-bars";
            case "tow, roll & bull bars": return prefix + "row-bars";

            default: return prefix;
        }
    }

    async handleSubmit() {
        var canSubmit = true;
        if (this.props.selfInspect.photoList && this.props.selfInspect.photoList.inspectionPhotoTypes) {
            for (var i = 0; i <= (this.props.selfInspect.photoList.inspectionPhotoTypes.length - 1); i++) {
                if (this.props.selfInspect.photoList.inspectionPhotoTypes[i].photo === undefined || this.props.selfInspect.photoList.inspectionPhotoTypes[i].photo === "") {
                    if (this.props.selfInspect.photoList.inspectionPhotoTypes[i].required) {
                        canSubmit = false;
                    }
                }
            }
            if (canSubmit) {
                this.props.redirectTo(CAPTURE_CAR_DETAILS)
            }
            else {
                this.props.getShowPhotoError()
            }
        } else {
        }

    }

    async handleCancel() {
        this.props.redirectTo(PERSONAL_INSURANCE)
    }

    async handleCaptureStep(step) {
        await this.props.dispatchSetSelfInspectStep(step);
        await this.props.dispatchShowSelfInspectStepsScreen();
    }

    public render() {
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }, { destination: PERSONAL_INSURANCE, description: "Car" }]
        if (this.props.selfInspect.selectedPersonalCover && this.props.selfInspect.selectedPersonalCover.product === 7) {
            BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }, { destination: PERSONAL_INSURANCE, description: "Motorbike" }]
        }
        let photos = <div></div>
        let row = <div></div>
        if (this.props.selfInspect.photoList && this.props.selfInspect.photoList.inspectionPhotoTypes) {
            photos = this.props.selfInspect.photoList.inspectionPhotoTypes.map((photoItem, index) => {
                if (photoItem.photo !== "") {
                    return <div className={this.getColClassName(photoItem.description.toLowerCase())} onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                        <div className={(index % 2 == 0) ? "capture-images-block-main photo-image-block-right" : "capture-images-block-main photo-image-block-left"}>
                            <Image src={photoItem.photo} alt={photoItem.description} />
                            <div className="capture-images-block-inner-container-overlay" title={photoItem.description}>
                                <div className="capture-images-block-icon"></div>
                                <span className={"capture-images-block-icon-description " + photoItem.imageName + "-label"}>{photoItem.description}</span>
                                <div className="capture-images-block-success-icon"></div>
                            </div>
                        </div>
                    </div>
                } else if (photoItem.description.toLowerCase() === "mileage reading" && this.props.selfInspect.mileage) {
                    return <div className={this.getColClassName(photoItem.description.toLowerCase())} onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                        <div className={(index % 2 == 0) ? "capture-images-block-main mileageblock-success photo-image-block-right pt-4" : "capture-images-block-main mileageblock-success photo-image-block-left pt-4"}>
                            <div className="mileage-block">
                                <p className="mileage-reading-label">{this.props.selfInspect.mileage}</p>
                            </div>
                            <span className="capture-images-block-icon-description">{photoItem.description}</span>
                            <div className="capture-images-block-success-icon"></div>
                        </div>
                    </div>
                } else {

                    return <div className={this.getColClassName(photoItem.description.toLowerCase())} onClick={() => this.handleCaptureStep(photoItem.description.toLowerCase())}>
                        <div className={(index % 2 == 0) ? "capture-images-block-main capture-image-block-right" : "capture-images-block-main capture-image-block-left"}>
                            <div className="capture-images-block-inner-container">
                                <div className={"capture-images-block-icon " + photoItem.imageName}></div>
                                <span className="capture-images-block-icon-description">{photoItem.description}</span>
                            </div>
                        </div>
                    </div>
                }
            });
        }
        return (
            <>
                <div id="SelfInspectCaptureImagesLanding" className="container-fluid new-page-margins">
                    <div className="new-breadcrumbwrapper breadcrumb-wrapper-capture-images-actual">
                        <KPBreadCrumb navList={BreadcrumbDetails} activePage="Self-inspection" />
                    </div>
                    <div className="row new-page-main-row">
                        <div className="StepBox captureimages-box" id="CarInspection">
                            <div className="captureimages-box-header">
                                <h3>{this.props.selfInspect.selectedPersonalCover.product === 7 ? 'Motorbike inspection' : 'Car inspection'}</h3>
                                <p className="Step-Description">{this.props.selfInspect.selectedPersonalCover.riskItems[0].description}</p>
                            </div>
                            <div className="row captureimages-box-header-bottom-border"></div>
                            {/*///  SSP Vertical Progress Bar Container ///*/}
                            {/*/// Change row class ssp-vpb-step-done-or-current to ssp-vpb-step-done / ssp-vpb-step-current ///*/}
                            <div className="ssp-vertical-progressbar-container">
                                {/*/// Step: Current ///*/}
                                <div className="row ssp-vpb-step-current">
                                    <div className="ssp-vpb-mark">
                                        <div className="ssp-vpb-mark-line">
                                            <div className="ssp-vpb-mark-icon"></div>
                                        </div>
                                    </div>
                                    <div className="col ssp-vpb-content">
                                        <div className="capture-images-step-holder">
                                            <h3>Snap a photo</h3>
                                            <p>Tap on an icon to take a photo of that part of your vehicle</p>
                                            {/*/// Photo Tiles ///*/}
                                            <div className="row captureimages-images-block">
                                                {photos}
                                            </div>
                                            {/*/// *** *** ///*/}
                                            <div className="row captureimages-buttons-block">
                                                <div className="col">
                                                    <button className="btn btn-block btn-outline-red font-weight-bold" type="button" id="Cancel" onClick={this.handleCancel}>Cancel</button>
                                                </div>
                                                <div className="col">
                                                    <button className="btn btn-block btn-solid-red font-weight-bold btn-red-disabled-handler" disabled={false} type="button" id="Next" onClick={this.handleSubmit}>Next</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/*/// Step End ///*/}
                                {/*/// Step ///*/}
                                <div className="row ssp-vpb-step-done-or-current">
                                    <div className="ssp-vpb-mark">
                                        <div className="ssp-vpb-mark-line">
                                            <div className="ssp-vpb-mark-icon"></div>
                                        </div>
                                    </div>
                                    <div className="col ssp-vpb-content">
                                        <span>
                                            {this.props.selfInspect.selectedPersonalCover.product === 7 ? 'Motorbike details' : 'Car details'}
                                        </span>
                                    </div>
                                </div>
                                {/*/// Step End ///*/}
                                {/*/// Step ///*/}
                                <div className="row ssp-vpb-step-done-or-current">
                                    <div className="ssp-vpb-mark">
                                        <div className="ssp-vpb-mark-line">
                                            <div className="ssp-vpb-mark-icon"></div>
                                        </div>
                                    </div>
                                    <div className="col ssp-vpb-content">
                                        <span>T's & C's</span>
                                    </div>
                                </div>
                                {/*/// Step End ///*/}
                                {/*/// Step ///*/}
                                <div className="row ssp-vpb-step-done-or-current">
                                    <div className="ssp-vpb-mark">
                                        <div className="ssp-vpb-mark-line">
                                            <div className="ssp-vpb-mark-icon"></div>
                                        </div>
                                    </div>
                                    <div className="col ssp-vpb-content">
                                        <span>Done</span>
                                    </div>
                                </div>
                                {/*/// Step End ///*/}
                                {/* /// End Vertical Progress Steps ///*/}
                            </div>
                            {/*/// End SSP Vertical Progress Bar Container ///*/}
                        </div>
                    </div>
                    <div className="row selfinspection-needhelp-row"> 
                        <div className="col">
                            <div className="d-none"> {/*{hidden for now untill we have a generic block}*/}
                          <NeedHelp
                                isClaims={true}
                                countryId={Number(this.props.profile.countryId)}
                                claimsEmail={this.props.ssp.claims_email}
                                contactUsTel={this.props.ssp.contactUs_tel}
                                handleCallMeBack={(e) => this.handleCallMeBack(e)}
                         />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        selfInspect: state.selfInspect,
        ssp:state.ssp
    }
}
const mapDispatchToProps = (dispatch: any) => {
    return {
        handleCallMeBack: () => dispatch(showCallMeModal(true)),
        getSelfInspectPhotos: () => dispatch(getSelfInspectPhotos()),
        getShowPhotoError: () => dispatch(showPhotoError()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchSetSelfInspectStep: (data) => dispatch(setSelfInspectStep(data)),
        dispatchShowSelfInspectStepsScreen: () => dispatch(showSelfInspectStepsScreen()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaptureImages);